// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panorama-modal .title-img[data-v-7855cddc]{width:100px;height:120px}.panorama-modal .no-img[data-v-7855cddc]{min-height:400px}", ""]);
// Exports
module.exports = exports;
